import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6eadc1ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container d-flex" }
const _hoisted_2 = { class: "register-warranty-text my-4 my-md-5 text-center flex-centered flex-wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h1 text-uppercase mb-4 mb-xl-5 col-12" }, "Register your Warranty", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center col-md-10 mb-4 mb-xl-5" }, "We make every effort to ensure that our products are built to last, and we stand behind them with an extended warranty for your peace of mind. Activate your warranty today by registering here.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary px-4 px-lg-5 py-2 py-lg-3 mb-2" }, "Register Now", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["col-12 py-0 py-md-4", {'register-warranty-banner' : _ctx.showBg}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createVNode(_component_router_link, {
          class: "text-decoration-none",
          to: { name: 'WarrantyRegistration' }
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ])
  ], 2))
}